module.exports = __webpack_public_path__ + "static/media/hourglass-small-transparent.109b3de6.gif";